import { Mobile, Scrollbar } from '../core'

$.fn.EscaladeChrome = function() {
  let self = this
  self.mobileChecker = new Mobile()
  self.path_items = self.find('.escalade-path')
  self.toggle_bg = self.find('.escalade-chrome__toggle-bg')

  return function() {
    $('#hover path').each(function() {
      let path = $(this)
      path.hover(function() {
        let pathID = $(this).attr('id').replace('-hover', '')
        self.find('.escalade-path[data-name="' + pathID + '"]').trigger('mouseenter').addClass('hover')
      }, function() {
        $('#paths path').css('stroke', '')
        self.find('.escalade-path').removeClass('hover')
      })
      path.click(function() {
        let pathID = $(this).attr('id').replace('-hover', '')
        if (self.mobileChecker.isMobile) {
          let scrollTarget = self.find('.escalade-path[data-name="' + pathID + '"]').offset().left + self.find('.escalade-chrome__side-bar > .scroller').scrollLeft() - 20
          if (scrollTarget < 50) { scrollTarget = 0 }
          self.find('.escalade-chrome__side-bar > .scroller').animate({
            'scrollLeft': scrollTarget + 'px',
          }, 350)
        } else {
          let scrollTarget = self.find('.escalade-path[data-name="' + pathID + '"]').offset().top - self.find('.escalade-chrome__side-bar').offset().top + self.find('.escalade-chrome__side-bar > .scroller').scrollTop()
          if (scrollTarget < 50) { scrollTarget = 0 }
          self.find('.escalade-chrome__side-bar > .scroller').animate({
            'scrollTop': scrollTarget + 'px',
          }, 350)
        }
      })
    })

    self.path_items.hover(function() {
      $('#paths path').css('stroke', '#ffffff')
      $('#' + $(this).data('name')).css('stroke', '#f25f1d')
    }, function() {
      $('#paths path').css('stroke', '')
    })

    self.toggle_bg.on('click', function() {
      if ($(this).hasClass('active')) {
        self.toggle_bg.removeClass('active')
        $('#bg-illustration').css('opacity', 1)
      } else {
        self.toggle_bg.addClass('active')
        $('#bg-illustration').css('opacity', 0)
      }
    })

    self.toggle_bg.on('mouseenter', function() {
      if (!$(this).hasClass('active') && !self.mobileChecker.isMobile) {
        self.toggle_bg.addClass('active')
        $('#bg-illustration').css('opacity', 0)
      }
    })
    self.toggle_bg.on('mouseleave', function() {
      if ($(this).hasClass('active') && !self.mobileChecker.isMobile) {
        self.toggle_bg.removeClass('active')
        $('#bg-illustration').css('opacity', 1)
      }
    })
    return self
  }()
}

export default {
  init() {
    $('.escalade-chrome').each(function() {
      $(this).EscaladeChrome()
    })
    this.attachScrollbars()
  },

  attachScrollbars() {
    /* Map scrollbars */
    new Scrollbar('.escalade-chrome__side-bar', {
      direction: 'vertical',
      mobile: false,
    })
    new Scrollbar('.escalade-chrome__side-bar', {
      direction: 'horizontal',
      desktop: false,
    })
    new Scrollbar('.escalade-illustration', {
      direction: 'horizontal',
      desktop: false,
    })
  },
}
